import { DEFAULT_LANGUAGE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import { getOptionListFromResult } from "../utils/OptionsUtils";
import { CHANGE_LANGUAGE_ACTION, LANGUAGE } from "./languageSelector";
import { createBackendErrorMessages, createErrorMessages, messagesReceived } from "./message";

export const REDUCER = "COUNTRY/";
export const COUNTRY_LIST_LOAD_SUCCESS = REDUCER + "COUNTRY_LIST_LOAD_SUCCESS";

// state props
export const COUNTRY_LIST = "countryList";
export const COUNTRY_OPTIONS = "countryOptions";

const initialState = {
  [COUNTRY_LIST]: [],
  [COUNTRY_OPTIONS]: [],
  [LANGUAGE]: DEFAULT_LANGUAGE,
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case COUNTRY_LIST_LOAD_SUCCESS:
      newState = {
        ...state,
        [COUNTRY_LIST]: action[COUNTRY_LIST],
        [COUNTRY_OPTIONS]: getOptionListFromResult(state[LANGUAGE], action[COUNTRY_LIST])
      };
      break;

    case CHANGE_LANGUAGE_ACTION:
      newState = {
        ...state,
        [LANGUAGE]: action[LANGUAGE],
        [COUNTRY_OPTIONS]: getOptionListFromResult(action[LANGUAGE], state[COUNTRY_LIST])
      };
      break;

    default:
      newState = { ...state };
      break;
  }

  return newState;
}

export function loadCountries() {
  return (dispatch) => {
    rest.doGet(`/admin/admin/predefined/country`).then(
      (result) => {
        if (result) {
          dispatch({ [TYPE_KEY]: COUNTRY_LIST_LOAD_SUCCESS, [COUNTRY_LIST]: result });
        } else {
          dispatch(messagesReceived(createErrorMessages(result)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}